module.exports = __webpack_public_path__ + "img/diners.60387665.svg";